import React from "react";
import { NavLink } from "react-router-dom";
import "./Projects.css";

const Projects = (props) => {
  const { id, name, img, des } = props.project;
  return (
    <div className="col-md-6 col-lg-4 col-sm-12">
      <div className="projects">
        <div>
          <img src={img} alt="" />
        </div>
        <h4 className="pt-4 projects-title">{name}</h4>
        <p className="paragrap">
          {des.slice(0, 88)}......
          <NavLink
            exact
            to={`/projectsdetails/${id}`}
            className="projects-details"
          >
            View Details
          </NavLink>
        </p>
      </div>
    </div>
  );
};

export default Projects;
